import { VALIDATION_ERRORS } from './enum';
import { FIELDS } from '../form-fields/enum';

const { COUNTRY_SELECT, LANGUAGE_SELECT, CHANNEL_SELECT, DESCRIPTION, KEYWORDS, VIDEO_TITLE } = FIELDS;

const { MANDATORY } = VALIDATION_ERRORS;

/**
 * @param {*} errors
 * @param {*} formData
 * @param {*} index - represent shadow logic of appending index of formConfig element of type CHANNEL_SELECT
 */
function validateChannels(errors, formData, index) {
  const channelsKey = `${CHANNEL_SELECT}_${index}`;

  if (!formData[channelsKey]) {
    errors[channelsKey] = MANDATORY;
  }

  if (formData[channelsKey] && formData[channelsKey].length === 0) {
    errors[channelsKey] = MANDATORY;
  }
}

/**
 * @param {*[]} formConfig
 * @param {*} formData
 */
export const videoFormValidate = (formConfig, formData) => {
  const errors = {};

  if (!formConfig || !formData) {
    return errors;
  }

  formConfig.forEach((cfg, index) => {
    if (cfg.config.required) {
      if (!formData[VIDEO_TITLE] && cfg.type === VIDEO_TITLE) {
        errors[VIDEO_TITLE] = MANDATORY;
      }

      if (cfg.type === CHANNEL_SELECT) {
        validateChannels(errors, formData, index);
      }

      if (!formData[KEYWORDS] && cfg.type === KEYWORDS) {
        errors[KEYWORDS] = MANDATORY;
      }

      if (!formData[DESCRIPTION] && cfg.type === DESCRIPTION) {
        errors[DESCRIPTION] = MANDATORY;
      }

      if (!formData[LANGUAGE_SELECT] && cfg.type === LANGUAGE_SELECT) {
        errors[LANGUAGE_SELECT] = MANDATORY;
      }

      if (!formData[COUNTRY_SELECT] && cfg.type === COUNTRY_SELECT) {
        errors[COUNTRY_SELECT] = MANDATORY;
      }
    }
  });

  return errors;
};
